import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import form_styles from "../../Form/Form.module.css";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import TitleSecondary from "../../Title/TitleSecondary";
import {ImageIllustration} from "../../Image/ImageIllustration";
import {ReactComponent as EnregistrerIcone} from "../../../icons/enregistrer.svg";
import BtnSave from "../../Button/BtnSave";
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import Routing from "../../../services/routing";

function ActiviteTypeCreation({ activiteType = null }) {
    const { user } = useUser();
    const {showModal, hideModal} = useModal();
    const [inputs, setInputs] = useState([]);
    const [activiteTypeId, setActiviteTypeId] = useState(activiteType?.actId || null);
    const [initialValues, setInitialValues] = useState({
        label: activiteType?.actLabel || "",
        slogan: activiteType?.actSlogan || "",
        description: activiteType?.actDescription || "",
        color_font: '#ffffff',
        color_bkg: '#ffffff',
    });
    let navigate = useNavigate();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    useEffect(() => {
        const newInputs = [
            {
                type: 'text',
                name: 'label',
                label: 'Label',
                placeholder: 'Aquavélo',
                value: activiteType?.actLabel || ""
            }, {
                type: 'text',
                name: 'slogan',
                label: 'Slogan',
                placeholder: 'Aquavélo, le sport qui vous veut du bien',
                value: activiteType?.actSlogan || "",
            }, {
                type: 'text',
                name: 'description',
                label: 'Description',
                placeholder: 'L\'aquavélo est une activité sportive qui se pratique dans l\'eau ou dans une piscine. Elle est idéale pour se muscler et se tonifier tout en douceur.',
                value: activiteType?.actDescription || "",
            }, {
                type: 'color',
                name: 'color_font',
                label: 'Couleur de police',
                value: activiteType?.actColorFont || "#333333"
            }, {
                type: 'color',
                name: 'color_bkg',
                label: 'Couleur de fond',
                value: activiteType?.actColorBkg || "#eeeeee"
            }
        ];
        setInputs(newInputs);

        const newInitialValues = newInputs.reduce((acc, input) => ({
            ...acc, [input.name]: input.value
        }), {});

        setInitialValues(newInitialValues);
    }, [activiteType]);

    const handleSubmit = async (values, {setSubmitting}) => {
        values.activiteType = activiteType?.actId || "";

        try {
            const response = await AxiosConfig.post(`/admin/activites/types/creation`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                activiteType = response.data.activiteType;
                setActiviteTypeId(response.data.activiteType.actId);
                navigate(`/admin/activites/types/${response.data.activiteType.actId}`);
            } else {
                handleError(response.data.message);
            }
        } catch (error) {
            console.error(error);
            handleError(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/activites/types/${activiteType.actId}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    return (
        <div style={{margin: '0 0 50px 0'}}>
            <TitleSecondary text={"Nouveau type d'activité"}/>

            {Object.keys(initialValues).length > 0 ? (
                <>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                        {({isSubmitting}) => (<Form>
                            {inputs.map((input, index) => (<FieldCustom {...input} key={index}/>))}
                            <div className={"barre_btn"}>
                                <button type={"button"} onClick={() => {
                                    navigate(-1)
                                }} className={"btn btn_danger"}><AnnulerIcone />Annuler
                                </button>
                                <BtnSave isSubmitting={isSubmitting}/>
                            </div>
                        </Form>)}
                    </Formik>

                    {/*}
                    {activiteType &&
                        <div style={{margin: "30px 0"}}>
                            <ImageIllustration src={`${activiteType?.actLogo}`}/>

                            <Formik
                                initialValues={{file: null}}
                                onSubmit={handleSubmitLogo}
                            >
                                {({setFieldValue, isSubmitting, errors}) => (
                                    <Form style={{display: "flex", flexDirection: "column"}}>
                                        <label className={styles.labelFileLogo} htmlFor="file">
                                    <AjouterIcone />
                                    Ajouter un logo
                                </label>

                                <input
                                    id="file"
                                    className={styles.inputFileLogo}
                                    name="file"
                                    type="file"
                                    onChange={(event) => {
                                        setFieldValue("file", event.currentTarget.files[0]);
                                    }}
                                />
                                { errors.file ? <div style={{color: 'red'}}>{errors.file}</div> : null }

                                <BtnSave isSubmitting={isSubmitting} text={"Enregistrer le logo"}/>
                            </Form>)}
                    </Formik>
                </div>
            }*/} </>
            ) : (<p>Chargement...</p>)}

            { activiteTypeId && <div style={{ margin: "20px 0 20px 0", color: "var(--clr-accent)", fontWeight: "500", padding: "6px", display: "flex", flexDirection: "column", gap: "8px" }}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminActiviteType,
                    params: {activiteTypeId}
                })}>
                    <FontAwesomeIcon icon={faExternalLink} />
                    Accéder
                </Link>

                <Link to={Routing.generate({
                    route: Routing.routes.adminActiviteType,
                    params: {activiteTypeId},
                    queryParams: {mode: "creation"}
                })}>
                    <FontAwesomeIcon icon={faExternalLink} />
                    Ajouter un logo
                </Link>
            </div> }
        </div>
    );
}

export default ActiviteTypeCreation;